/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable eqeqeq */
import React, { useEffect, useRef, useState } from "react";
import ReactPlayer from "react-player/lazy";
import {
  FaPlay,
  FaPause,
  FaVolumeUp,
  FaVolumeMute,
  FaExpand,
  FaVolumeDown,
  FaCompress,
} from "react-icons/fa";
import { AiTwotoneSetting } from "react-icons/ai";
import Slider from "@material-ui/core/Slider";
import styles from "./LiveVideoPlayer.module.scss";
import { useDispatch } from "react-redux";
import { fetchLiveUrl } from "../../actions/watchLiveAction";
import { useLocation } from "react-router-dom";
import ReactFullscreen from "react-easyfullscreen";
import { useSeasonal } from "../../logic/Seasonal";
import { Spinner } from "react-bootstrap";

const LiveVideoPlayer = ({
  url,
  fullscreen,
  setFullscreen,
  playError,
  setPlayError,
  live,
  play,
  setPlay,
  config,
}) => {
  const [videos, setVideos] = useState({});
  const [volume, setVolume] = useState(1);
  const [selectedVideo, setSelectedVideo] = useState(0);
  const [settingDisplay, setSettingDisplay] = useState(false);
  const [toggleScreen, setToggleScreen] = useState(false);
  const [showPlay, setShowPlay] = useState(true);
  const [showControls, setShowControls] = useState(0); // Show controls and hide
  const [playerReady, setPlayerReady] = useState(false); // Video player buffering loading

  const player = useRef();
  const dispatch = useDispatch();
  const location = useLocation();
  let path = location.pathname;
  const { classes } = useSeasonal();
  // let newPlay = false;

  const handleChangeVolume = (event, newValue) => {
    setVolume(newValue);

    localStorage.setItem(
      "SHALOM_WORLD_BROWSER_volume",
      JSON.stringify({
        creation: Math.round(new Date().getTime() / 1000),
        volume: newValue,
      })
    );
  };

  const getResolutionFromWidth = (res) => {
    if (res > 1500) return "Full HD";
    else if (res > 1100) return "HD";
    else if (res > 800) return "SD";
    else if (res >= 640) return "Low";
    else if (res === "0") return "Auto";
  };

  const handleSelectResolution = (res) => {
    setPlay(true);
    setShowPlay(true);
  };

  /**
   * @desc Fetch resolution from the m3u8 url provided.
   */
  useEffect(() => {
    setPlayError(true);
    if (url) {
      dispatch(fetchLiveUrl(url)).then((res) => {
        let a = res.data.split(",");
        let arr = a.filter((item) => item.includes("RESOLUTION"));
        let obj = {};
        arr.map((item, index) => {
          if (index === 0) {
            obj["0"] = url; //Auto url for m3u8
          }
          const key = item.search("https");
          const urlEnd = item.search("#");
          const resolution = item.slice(0, key).split("x");
          obj[parseFloat(resolution[0].slice(11))] = item.slice(key, urlEnd);
        });
        setVideos(obj);
      });
    }
  }, [dispatch, setPlayError, url]);

  /**
   * @desc hide controls after certain interval
   */

  useEffect(() => {
    let myTimeout = setInterval(() => {
      setShowControls(false);
      setSettingDisplay(false);
    }, 12000);
    return () => {
      clearTimeout(myTimeout);
    };
  }, []);

  document.addEventListener("mousemove", (e) => {
    setShowControls(true);
  });

  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);

    // Don't forget to clean up
    return function cleanup() {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  document.addEventListener("mousemove", (e) => {
    setShowControls(true);
  });

  function handleKeyDown(event) {
    if (fullscreen) {
      if (event.keyCode === 32) {
        setPlay(!play);
        setSettingDisplay(false);
      }

      if (event.keyCode === 27) {
        setShowControls(true);
        setToggleScreen(false);
        setFullscreen(false);
        setSettingDisplay(false);
      }
    }
  }

  useEffect(() => {
    setPlay(false);
    if (localStorage.getItem("SHALOM_WORLD_BROWSER_volume") != null) {
      //setIsLoading(true);
      let videoVolume = JSON.parse(
        localStorage.getItem("SHALOM_WORLD_BROWSER_volume")
      );

      setTimeout(() => {
        setVolume(0);
        //setIsLoading(false);
        if (videoVolume?.volume) {
          setVolume(videoVolume.volume);
        }
      }, 2000);
    }
  }, []);

  /**
   * @desc set  volume mute/umute
   */
  const handleVolumeControl = (event) => {
    if (volume === 0) {
      let v = 1;
      if (localStorage.getItem("SHALOM_WORLD_BROWSER_volume")) {
        let vArr = JSON.parse(
          localStorage.getItem("SHALOM_WORLD_BROWSER_volume")
        );
        if (vArr?.volume && vArr.volume > 0) {
          v = vArr?.volume;
        }
      }
      setVolume(v);
    } else {
      setVolume(0);
    }
  };

  document.addEventListener("mousemove", (e) => {
    setShowControls(true);
  });

  const handlePlaying = () => {
    if (!showPlay) {
      setShowPlay(true);
    }
  };

  if (document.addEventListener) {
    document.addEventListener("webkitfullscreenchange", exitHandler, false);
    document.addEventListener("mozfullscreenchange", exitHandler, false);
    document.addEventListener("fullscreenchange", exitHandler, false);
    document.addEventListener("MSFullscreenChange", exitHandler, false);
  }

  function exitHandler() {
    if (
      !document.webkitIsFullScreen &&
      !document.mozFullScreen &&
      !document.msFullscreenElement
    ) {
      setFullscreen(false);
      setToggleScreen(false);
    }
  }

  const handleOnBufferEnd = (event, newValue) => {
    setPlayerReady(true);
  };

  const handleOnBufferStart = (event, newValue) => {
    setPlayerReady(false);
  };

  const handleOnReady = (event) => {
    setPlayerReady(true);
  };

  return (
    <>
      <ReactFullscreen>
        {({ ref, onRequest, onExit }) => (
          <div
            id="VideoPlayerWrap"
            className={`${styles.videoPlayer} player1 desktop-videoplayer`}
            ref={ref}
            style={{ width: `100%`, height: `100%` }}
          >
            {!play && (
              <span
                className={`${styles.actionPlay} ${classes.playClass} ${classes.borderOnly} `}
                onClick={() => {
                  setPlay(true);
                  setSettingDisplay(false);
                }}
              ></span>
            )}


            {url === "" ? (
              <div className={`${styles.preloader} ${classes.loaderColor}`}>
                <Spinner
                  as="span"
                  animation="border"
                  size="md"
                  role="status"
                  aria-hidden="true"
                />
              </div>
            ) : (
              <div
                className={`${styles.custom_live_player} custom_live_player`}
                onClick={() => {
                  setPlay((state) => !state);
                  setShowPlay((state) => !state);
                }}
              >
                {!playerReady && play && (
                  <div className={`${styles.preloader} ${classes.loaderColor}`}>
                    <Spinner
                      as="span"
                      animation="border"
                      size="md"
                      role="status"
                      aria-hidden="true"
                    />
                  </div>
                )}

                <ReactPlayer
                  ref={player}
                  url={videos[selectedVideo] || url}
                  className={styles.player}
                  volume={volume}
                  width={"100%"}
                  config={{
                    file: {
                      hlsOptions: config,
                    },
                  }}
                  playing={play}
                  height={path === "/" ? "100%" : "100vh"}
                  controls={false}
                  onContextMenu={(e) => e.preventDefault()}
                  playsInline
                  onPlay={handlePlaying}
                  onBufferEnd={handleOnBufferEnd}
                  onBuffer={handleOnBufferStart}
                  onReady={handleOnReady}
                  bufferOptions={{ hls: { maxBufferSize: 10e6 } }}

                />

                <div
                  style={{
                    background: "rgba(0,0,0,.3)",
                    position: "absolute",
                    zIndex: 1,
                    top: "0",
                    right: "0",
                    bottom: "0",
                    left: "0",
                    opacity: !play ? "0" : "1",
                    transition: "all .2s",
                    visibility: !play ? "visible" : "hidden",
                  }}
                ></div>
              </div>
            )}
            <div
              className={`${styles.control} custom-controls`}
              style={{ opacity: showControls ? 1 : 0 }}
            >
              <button
                bclassName="btn-play"
                onClick={() => {
                  if (url == "") {
                    setPlayError(true);
                  }
                  setPlay((state) => !state);
                  setShowPlay((state) => !state);
                }}
              >
                {!play ? <FaPlay /> : <FaPause />}
              </button>


              <button className="btn-volume" onClick={handleVolumeControl}>
                {volume === 1 ? (
                  <FaVolumeUp />
                ) : volume > 0 ? (
                  <FaVolumeDown />
                ) : (
                  <FaVolumeMute />
                )}
              </button>

              <div className={styles.slider}>
                <Slider
                  value={volume}
                  min={0}
                  step={0.1}
                  max={1}
                  scale={(x) => x ** 10}
                  valueLabelDisplay="off"
                  onChange={handleChangeVolume}
                />
              </div>
              <div className={styles.liveText}>LIVE</div>

              {!toggleScreen ? (
                <button
                  className={styles.rightIcon}
                  onClick={() => {
                    setToggleScreen(true);
                    onRequest();
                  }}
                >
                  <FaExpand />
                </button>
              ) : (
                <button
                  className={styles.rightIcon}
                  onClick={() => {
                    setToggleScreen(false);
                    onExit();
                  }}
                >
                  <FaCompress />
                </button>
              )}

              <button
                className={styles.setting}
                onClick={() => {
                  setSettingDisplay(!settingDisplay);
                }}
              >
                <ul style={{ display: settingDisplay ? "block" : "none" }}>
                  {Object.keys(videos)?.length > 0 &&
                    Object.keys(videos)
                      .reverse()
                      .map((video, index) => {
                        return (
                          <>
                            <li
                              // eslint-disable-next-line eqeqeq
                              className={`${selectedVideo == video ? styles.selected : ""
                                }`}
                              onClick={() => {
                                setSelectedVideo(video);
                                handleSelectResolution(video);
                              }}
                            >
                              {getResolutionFromWidth(video)}
                            </li>
                          </>
                        );
                      })}
                </ul>
                <AiTwotoneSetting />
              </button>
            </div>
          </div>
        )}
      </ReactFullscreen>
    </>
  );
};

export default LiveVideoPlayer;
